module.exports = __webpack_public_path__ + "img/PicAndFont.d9654dbc.png";